import React, {useRef, useState, useCallback, useEffect} from 'react';
import {getVolumeFromEvent} from 'components/cirklon/useParameterMouse.js';

export const useMixerMouse = ({
    parameter,
    min,
    max,
    height,
    root=1,
    ref
}) => {
    let [mouseDown, setMouseDown] = useState(false);

    const onMouseDown = useCallback((e) => {
        e.stopPropagation();
        let newVolume = getVolumeFromEvent(e, 'a', min, max, height, root, ref.current);
        parameter.set(newVolume, false);
        setMouseDown(true);
    }, [parameter, setMouseDown]);

    const onMouseMove = useCallback((e) => {
        e.stopPropagation();
        if (!mouseDown) {
            return;
        }
        let newVolume = getVolumeFromEvent(e, 'a', min, max, height, root, ref.current);
        parameter.set(newVolume, false);
    }, [parameter, mouseDown]);

    const onMouseClear = useCallback((e) => {
        setMouseDown(false);
    }, [setMouseDown]);

    return {onMouseMove, onMouseDown, onMouseClear};

};
 
